<template>
  <div class="context">
    <div class="">姓名: {{ userInfo.name }}</div>
    <div class="">性别: {{ ["", "男", "女"][userInfo.sex] }}</div>
    <div class="">专业: {{ userInfo.proName }}</div>
    <div class="">专业层次:{{ userInfo.learnLevel }}</div>

    <div class="">身份证号:{{ userInfo.idNo }}</div>
    <div style="width:65%;">
      是否申请学位：
      <a-radio-group v-model="radioVal" name="radioGroup">
        <a-radio value="true">是</a-radio>
        <a-radio value="false">否</a-radio>
      </a-radio-group>
    </div>

    <div style="padding:20px 0 0 40%">
      <a-button @click="handleSubmit" type="primary" class="btn"> 提交 </a-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "degreeApplication",
  data: function () {
    return {
      radioVal: null,
      stuDegreeData: null,
    };
  },
  created() {
    this.axios.get(`/degree/stuDegree/queryById`).then((res) => {
      if (res.code === 200) {
        this.stuDegreeData = res;
        if (null != res.result) {
          this.radioVal = "true";
        } else {
          this.radioVal = "false";
        }
      }
    });
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    handleSubmit() {
      this.axios
        .post(`/degree/stuDegree/addOrUpdate?isApply=` + this.radioVal)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("提交成功");
          }
        });
    },
    change() {
      this.axios
        .post(`/degree/stuDegree/addOrUpdate?isApply=` + this.radioVal)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("提交成功");
          }
        });
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl';
.context {
  margin-top: 30px;
  font-weight: 700;

  .btn {
    background: $bgColor !important;
    border:none;
    width:100px
  }

  div {
    padding: 10px 0 10px 30%;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/degreeApplication.vue